import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { FilterOption, ignoreValue } from '@k2/common/filters';
import { K2SelectOption } from '@k2/common/k2-select/k2-select-option';
import { getControlName } from '@k2/common/filters/utils';

@Component({
    selector: 'k2-select-filter',
    templateUrl: 'k2-select-filter.component.html',
    styleUrls: ['k2-select-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
    host: {
      '[style.width]': 'size'
    }
})
export class K2SelectFilterComponent {
  private _control: UntypedFormControl;

  get control(): UntypedFormControl {
    return this._control;
  }
  @Input() set control(value: UntypedFormControl) {
    this._control = value;
    this.matSelectId = getControlName(value);
  }
  @Input() options: FilterOption[];
  @Input() placeholder = 'all';
  @Input() size: string = '150px';
  @Output() onChange = new EventEmitter<string | number>();

  matSelectId: string | null = null;

  constructor(private cdr: ChangeDetectorRef) {}

  get selectOptions(): K2SelectOption[] {
    const options = this.options || [];
    const select2Options = options.map(option => ({
      id: option.value,
      text: option.label
    }));

    if (this.placeholder === null) return select2Options;

    return [{ id: ignoreValue, text: this.placeholder }, ...select2Options];
  }

  setValue(value: any, emitEvent = true) {
    this.control.patchValue(value, { emitEvent });
    this.onChange.emit(value);
    this.cdr.detectChanges();
  }
}
